// ---- Movie Tracking Types ----

export type WatchStatus = "want_to_watch" | "watching" | "watched";

export const MOVIE_GENRES = [
  "Action",
  "Adventure",
  "Animation",
  "Comedy",
  "Crime",
  "Documentary",
  "Drama",
  "Family",
  "Fantasy",
  "Horror",
  "Music",
  "Mystery",
  "Romance",
  "Science Fiction",
  "Thriller",
  "War",
  "Western",
  "Other",
] as const;

export type MovieGenre = (typeof MOVIE_GENRES)[number];

export type Movie = {
  id: string;
  userId: string;
  title: string;
  director?: string;
  posterUrl?: string;          // TMDB poster
  genre?: string;
  runtime?: number;            // minutes
  year?: number;               // release year
  status: WatchStatus;
  rating?: number;             // 1-5 stars
  review?: string;             // personal notes
  tmdbId?: number;             // for deduplication
  dateAdded: string;           // ISO date
  dateStarted?: string;        // when moved to "watching"
  dateWatched?: string;        // when moved to "watched"
};

export type TMDBSearchResult = {
  id: number;
  title: string;
  posterPath?: string;
  releaseDate?: string;
  overview?: string;
  genreIds?: number[];
  runtime?: number;
};

/** Shared movie catalog — community-populated, not per-user */
export type CatalogMovie = {
  id: string;
  title: string;
  titleLower: string;
  director?: string;
  directorLower?: string;
  posterUrl?: string;
  genre?: string;
  runtime?: number;
  year?: number;
  tmdbId?: number;
  overview?: string;
  addedBy: string;
  watchersCount: number;
  avgRating: number;
  totalRatings: number;
  createdAt: string;
  updatedAt: string;
};
